// Facts every screen shares. The help address is decision 38: the footer and the login help.
export const SITE = {
  company: 'Bull and Bear Investments Limited',
  helpEmail: 'adam@adamslee.co.uk',
  // the only copy of the terms (version 2.2) lives on poyt.adamslee.co.uk
  termsUrl: 'https://poyt.adamslee.co.uk/terms',
  privacyUrl: 'https://poyt.adamslee.co.uk/privacy',
  titleSuffix: 'Adam Slee Members',
  // the hub's code follows the shared email OTP settings: 8 digits, an hour (CLAUDE.md)
  codeLength: 8,
}

export function setTitle(page) {
  document.title = page ? `${page} | ${SITE.titleSuffix}` : SITE.titleSuffix
}
